import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SidebarService } from '@ibe/services/ui';
import { INDRABookingService } from '@ibe.services/booking.indra.service';
import {
	ANCILLARY_PRODUCT_GROUP_CODE_MEAL,
	TRANSLATION_ANCILLARY_DETAILED,
	TRANSLATION_ANCILLARY_GROUP,
	ANCILLARY_GROUP_MEAL_LIST,
	BRAND_DESCRIPTION_TOP_EXECUTIVE,
	BRAND_DESCRIPTION_EXECUTIVE,
	PAX_TYPE_INFANT_CODE,
	ANCILLARY_GROUP_DEPORTEES_LIST,
	ANCILLARY_GROUP_MEDICAL_ASSISTANCE_LIST,
	SSR_CODE_UNACCOMPANIED_MINOR,
	UNCONFIRMED_CODES,
	EXTRAS_ANCILLARY_MEAL,
	BRAND_NAMES_MAP,
	SESSION_VAR_KEY_LANGUAGE,
	DEFAULT_LANGUAGE,
	SESSION_VAR_KEY_MARKET,
	DEFAULT_MARKET,
	SPECIAL_CASE_MARKET_LANGUAGE_MAP
} from '@ibe.config';
import { INDRAPax } from '@ibe.models/pax.indra.model.lib';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRASegment } from '@ibe.models/segment.indra.model.lib';
import { INDRAIncludedAncillaryDetailForSegment, INDRAIncludedAncillaryCodeCount } from '@ibe.models/ancillary.indra.model.lib';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRABookedTripDetails } from '@ibe.models/booked-trip-details.indra.model.lib';
import { INDRAAncillariesShoppingCartService } from '@ibe.services/ancillaries-shopping-cart.indra.service';
import { INDRATotalSummaryService } from '@ibe.services/total-summary.service';
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';
import { Subscription } from '../../../../../../../node_modules/rxjs';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';


@Component({
	selector: 'app-details-snacks',
	templateUrl: './details-snacks.indra.component.html',
	styleUrls: ['./details-snacks.component.scss']
})
export class INDRADetailsSnacksComponent implements OnInit, OnDestroy {

	flight;
	flightIdentifier: string;
	hasLayover = false;

	passengers: INDRAPax[] = [];
	paxFareInfoFeatures = [];
	paxPurchaseFeatures = [];
	_hasEdit = true;
	hasInfant = false;
	countUnit = '';

	hasDeporteeFlag = false; // this will be utilized for detecting deportee/under lawful custody ancillary on prm
	hasMedicalAssistanceFlag = false; // this will be utilized for detecting requested medical assistance on prm
	hasUMNRFlag = false; // this will be utilized for detecting if unaccompnied minor SSR was included on prm
	ancillaryGroup: string;
	bookedTrip: INDRABookedTripDetails;
	IfAllPassengersAreChildren = false;
	hasIssuedTicket = true; // used for checking if PNR has issued ticket/s
	showAddButton: boolean = true;
	isFlagged: boolean = false;
	totalSummarySubscription: Subscription;
	
	isBookingView: boolean = false;
	isReviewTTTCompletion: boolean = false;
	brandDescription: string;

	constructor(
		protected sidebarService: SidebarService,
		protected route: ActivatedRoute,
		protected router: Router,
		private bookingService: INDRABookingService,
		private ibeAdminService: INDRAIbeAdminService,
		private bfmStorage: INDRABFMDataStorageService,
		public ancillaryCartService: INDRAAncillariesShoppingCartService,
		private totalSummaryService: INDRATotalSummaryService,
		private bookingSearchService: INDRABookingSearchService,
		private ibeAdminConfigService: INDRAIbeAdminConfigService
	) { 
		if (this.router.url.includes('/my-bookings/view/')) this.isBookingView = true;
		if (this.router.url.includes('/review-your-trip/deeplink/')) this.isReviewTTTCompletion = true;
	}



	ngOnInit() {
		this.flightIdentifier = this.route.snapshot.paramMap.get('flight');
		this.flight = this.bookingService.INDRA_getBookedFlight(this.flightIdentifier);
		this.INDRA_showAddButton();
		this.passengers = this.bookingService.INDRA_getPaxInfo();
		this.hasLayover = this.INDRA_checkIndirectFlight();
		this.ancillaryGroup = ANCILLARY_PRODUCT_GROUP_CODE_MEAL;
		this.brandDescription = this.INDRA_getBrandDescription();

		let fareInfoAncillary = this.bookingService.INDRA_getPassengersAncillaryFareInformation(ANCILLARY_PRODUCT_GROUP_CODE_MEAL, this.flight.idFlight.toString());
		let purchasedAncillaryWithSegmentInfo = this.bookingService.INDRA_getPassengersPurchasedAncillaryWithSegmentInfo(ANCILLARY_PRODUCT_GROUP_CODE_MEAL, this.flight.idFlight.toString(), this.flightIdentifier);

		this.hasIssuedTicket = this.bookingService.INDRA_checkIfPNRIssuedTickets();

		this.bookedTrip = this.bfmStorage.INDRA_getActiveBookedTrip();
		this.IfAllPassengersAreChildren = this.bookingService.INDRA_checkIfAllPassengersAreChildren(this.passengers);
		this.passengers.forEach(pax => {
			const fareInfoindex = fareInfoAncillary.findIndex(
				object => object[pax.idPax]
			);
			let paxfareAncillaries = fareInfoAncillary[fareInfoindex];
			this.paxFareInfoFeatures.push({
				[pax.idPax] : this.INDRA_constructAncillaryList(paxfareAncillaries[pax.idPax])
			});
			;
			const purchasedIndex = purchasedAncillaryWithSegmentInfo.findIndex(
				object => object[pax.idPax]
			);
			if (purchasedIndex === -1) {
				this.paxPurchaseFeatures.push({
					[pax.idPax] : []
				});
			} else {
				let paxpurchasedAncillaries = purchasedAncillaryWithSegmentInfo[purchasedIndex];
				this.paxPurchaseFeatures.push({
					[pax.idPax] : this.INDRA_constructAncillaryListForPurchased(paxpurchasedAncillaries[pax.idPax])
				});

				//sort ascending based on segmentID
				this.paxPurchaseFeatures.sort((first, second) =>  (Number(first.segmentId) > Number(second.segmentId) ? -1 : 1));
			}
			if (pax.typePax === PAX_TYPE_INFANT_CODE) {
				this.hasInfant = true;
			}

			if (pax.prm) {
				let deporteePRM = pax.prm.filter(prmItem => ANCILLARY_GROUP_DEPORTEES_LIST.includes(prmItem.type));
				let medicalAssistancePRM = pax.prm.filter(prmItem => ANCILLARY_GROUP_MEDICAL_ASSISTANCE_LIST.includes(prmItem.type));
				let umnrPRM = pax.prm.filter(prmItem => SSR_CODE_UNACCOMPANIED_MINOR == prmItem.type);

				if (deporteePRM.length > 0) {
					this.hasDeporteeFlag = true;
				}

				if (medicalAssistancePRM.length > 0) {
					this.hasMedicalAssistanceFlag = true;
				}

				if (umnrPRM.length > 0) {
					this.hasUMNRFlag = true;
				}
			}
		});
		this.totalSummarySubscription = this.totalSummaryService.INDRA_getObservableTotalSummary().subscribe(
			data => {
				if (data) {
					this.isFlagged = this.bookingService.INDRA_isUnavailableFlight(this.flight.idFlight, data);
				}
			}
		);

	}

	INDRA_gotoURL(key) {
		const languageCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
								sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE).toLowerCase() : DEFAULT_LANGUAGE;
		const languageMap = SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] ? SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] : languageCode;
		const marketCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
								sessionStorage.getItem(SESSION_VAR_KEY_MARKET).toLowerCase() : DEFAULT_MARKET;
		const urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
		const urlNavigate = urlIbeAdmin.replace('${lang}', `${languageMap}`).replace('${market}', `${marketCode}`);
		return window.open(urlNavigate);
	}

	INDRA_constructAncillaryList(list: string[]) {
		let returnValue = '';
		this.countUnit = this.INDRA_getTranslation('whatsIncludedSidebars.detailsSnacks.texts.countUnitSingular');
		list.forEach(item => {
			if (returnValue.length === 0) {
				returnValue = '1' + this.countUnit + ' ' + this.INDRA_getTranslation(`${TRANSLATION_ANCILLARY_DETAILED + item}`);
			} else {
				returnValue = returnValue + ', ' + '1' + this.countUnit + ' ' + this.INDRA_getTranslation(`${TRANSLATION_ANCILLARY_DETAILED + item}`);
			}
		});

		return returnValue;
	}

	INDRA_mergeAncillaries(fareInfoAncillary, purchasedAncillary) {
		let returnValue = [];
		this.passengers.forEach(pax => {
			let mergedAncillaries = [];
			const fareInfoindex = fareInfoAncillary.findIndex(
				object => object[pax.idPax]
			);
			let paxfareAncillaries = fareInfoAncillary[fareInfoindex];

			const purchasedIndex = purchasedAncillary.findIndex(
				object => object[pax.idPax]
			);
			let paxPurchasedAncillaries = purchasedAncillary[purchasedIndex];

			mergedAncillaries = paxfareAncillaries[pax.idPax].concat(paxPurchasedAncillaries[pax.idPax]);
			returnValue.push({
				[pax.idPax]: mergedAncillaries
			});
		});
		return returnValue;
	}

	// SIDEBAR INTERACTIONS

	/** Close sidebar and clear secondary route */
	private INDRA_closeSidebar() {
		this.sidebarService.closeSidebar();
		this.router.navigate([{ outlets: { sidebar: null } }], { replaceUrl: true });
	}

	/** Handles close action intention **/
	INDRA_handleClose() { this.INDRA_closeSidebar(); }

	openMealSidebar() {
		this.sidebarService.openSidebar(['ancillaries--special-meals', { flight: this.flightIdentifier }]);
	}

	INDRA_capitalize(str: string) {
		if (str.length > 0) {
			return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
		}
		return '';
	}

	INDRA_printPassengerName(pax: INDRAPax) {
		return this.INDRA_capitalize(pax.name) + ' ' + this.INDRA_capitalize(pax.surname);
	}

	INDRA_printBrand() {
		return this.brandDescription;
	}

	INDRA_getTranslation(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}

	INDRA_getAncillaryForPassenger(list: any, idPax: number) {
		let returnValue;
		const index = list.findIndex(
			item => Object.keys(item)[0] === idPax.toString()
		);
		if (list) {
			let paxAncillary = list[index];
			returnValue = paxAncillary[idPax];
			return returnValue;
		}

	}

	INDRA_getGroupLabel() {
		let groupList: string[] = ANCILLARY_GROUP_MEAL_LIST;
		return this.INDRA_getTranslation(`${TRANSLATION_ANCILLARY_GROUP + groupList[0]}`);
	}

	INDRA_showUpgrade() {
		// let brand = this.INDRA_printBrand();
		return !(this.brandDescription === BRAND_DESCRIPTION_TOP_EXECUTIVE || this.brandDescription === BRAND_DESCRIPTION_EXECUTIVE || this.hasDeporteeFlag || this.hasMedicalAssistanceFlag || this.hasUMNRFlag || this.IfAllPassengersAreChildren || !this.hasIssuedTicket) && !this.isFlagged;
	}


	INDRA_getPurchasedAncillaryForPassenger(idPax: number): string[] {
		let returnValue = [];
		const index = this.paxPurchaseFeatures.findIndex(
			item => Object.keys(item)[0] === idPax.toString()
		);
		if (this.paxPurchaseFeatures) {
			let paxAncillary = this.paxPurchaseFeatures[index];
			returnValue = paxAncillary[idPax];
			return returnValue;
		}
	}

	INDRA_displaySegmentInfo(segmentId: string) {
		let returnValue = '';
		if (this.hasLayover) {
			let segmentInfo: INDRASegment = this.bookingService.INDRA_getSegment(this.flightIdentifier, segmentId);
			let segmentDeparture = this.bookingService.INDRA_getLocation(segmentInfo.departureAirport);
			let segmentArrival = this.bookingService.INDRA_getLocation(segmentInfo.arrivalAirport);
			returnValue = ' ' + segmentDeparture.city + ' - ' + segmentArrival.city;
		}
		return returnValue;
	}

	INDRA_checkIndirectFlight() {
		const segments: string[] = this.bookingService.INDRA_getSegmentIDs(this.flightIdentifier);
		let flag = false;
		if (segments.length > 1) {
			flag = true;
		}
		return flag;
	}

	INDRA_constructAncillaryListForPurchased(list: any[]): INDRAIncludedAncillaryDetailForSegment[] {
		let returnValue: INDRAIncludedAncillaryDetailForSegment[] = [];
		list.forEach(segment => {
			let descriptionForSegment = '';
			// flag for unconfirmed codes
			let unconfirmed: boolean = false;
			segment.ancillaryList.forEach((ancillary: INDRAIncludedAncillaryCodeCount) => {
				if (ancillary.count > 1) {
					this.countUnit = this.INDRA_getTranslation('whatsIncludedSidebars.detailsSnacks.texts.countUnitPlural');
				} else {
					this.countUnit = this.INDRA_getTranslation('whatsIncludedSidebars.detailsSnacks.texts.countUnitSingular');
				}

				if (descriptionForSegment.length === 0) {
					descriptionForSegment = ancillary.count + this.countUnit + ' ' + this.INDRA_getTranslation(`${TRANSLATION_ANCILLARY_DETAILED + ancillary.code}`);
				} else {
					descriptionForSegment = descriptionForSegment + ', ' + ancillary.count + this.countUnit + ' ' + this.INDRA_getTranslation(`${TRANSLATION_ANCILLARY_DETAILED + ancillary.code}`);
				}
				// ANCILLARIES WARNING
				if (ancillary.unconfirmed) {
					unconfirmed = true;
				}

			});
			returnValue.push({
				ancillaryDetail: descriptionForSegment,
				segmentId: segment.segmentId,
				// ANCILLARIES WARNING
				unconfirmed: unconfirmed
			});
		});

		return returnValue;
	}

	INDRA_getMealAncillaryCatalog() {

		let catalogs = null;
		if (this.bookedTrip["ancillaries-data"] && this.bookedTrip["ancillaries-data"].bundleList) {
			catalogs = this.bookedTrip["ancillaries-data"].bundleList.find((bundleItem) => bundleItem['ancillaryList'][0].type === ANCILLARY_PRODUCT_GROUP_CODE_MEAL);
		}

		if (catalogs && catalogs.ancillaryList && catalogs.ancillaryList.length > 0 )  {
			return catalogs.ancillaryList[0].catalog;
		}
		return null;
	}

	INDRA_showSpecialMeals() {
		let catalog = this.INDRA_getMealAncillaryCatalog();
		let idInfoSegment = this.flight.listSegment;
		let result = false;
		if (catalog && this.flight && idInfoSegment.length > 0) {
			idInfoSegment.forEach(segment => {
				if (catalog.find((item) => (item.flightId.toString() == this.flight.idFlight.toString() && item.segmentId.toString() == segment.idInfoSegment.toString()))) {
					result = true;
					return result;
				}
			});
		}
		return result;
	}

	INDRA_checkIfCodeShare() {
		return (this.bookingService.INDRA_checkIfCodeShare(this.flight.listSegment) ? true : false);
	}

	INDRA_upgradeWithCash() {
		let activeBookedTrip = this.bfmStorage.INDRA_getActiveBookedTrip();
		let link = '/my-bookings/upgrade-with-cash/' + activeBookedTrip.data.pnr;
		let params = { flight: this.flight.assignedFlightId }
		this.sidebarService.closeSidebar();
		this.bookingService.INDRA_linkRouteData(link, params);
	}

	INDRA_showAddButton() {
		const ancillaryAvailable = this.bookingService.INDRA_isAncillaryAvailable(EXTRAS_ANCILLARY_MEAL, this.flightIdentifier);
		if (!ancillaryAvailable || !this.hasIssuedTicket) {
			this.showAddButton = false;
		}
	}

	ngOnDestroy() {
		if (this.totalSummarySubscription) this.totalSummarySubscription.unsubscribe();
	}

	INDRA_getBrandDescription() {
		if (this.isBookingView || this.isReviewTTTCompletion) {
			if (!this.flight.fareFamily) return '';
			const brandCode = this.bookingSearchService.INDRA_getBrandCodeFromAmadeus(this.flight.fareFamily);
			return brandCode ? BRAND_NAMES_MAP[brandCode] : '';
		} else {
			this.bookingService.INDRA_getBrand(this.flightIdentifier.toString());
		}
	}
}
